/**
 * @generated SignedSource<<84bf4ba09639db99237d89137a02477f>>
 * @relayHash a927de0ec765e23dba1d543e24965073
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 64e256d56df5d7c2723d7002d8836219f0e795e080d865d9e8a8b8724d659c0c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentProfileCardQuery$variables = {
  agentAri: string;
  cloudId: string;
  fetchByIdentity: boolean;
  identityAccountId: string;
};
export type AgentProfileCardQuery$data = {
  readonly agentStudio_agentById?: {
    readonly agent: {
      readonly name: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
  } | null;
  readonly agentStudio_agentByIdentityAccountId?: {
    readonly agent: {
      readonly name: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
  } | null;
};
export type AgentProfileCardQuery = {
  response: AgentProfileCardQuery$data;
  variables: AgentProfileCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchByIdentity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identityAccountId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = [
  {
    "fragment": {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "kind": "FragmentSpread",
          "name": "AgentCardRelay_StudioBrowseKit"
        }
      ],
      "type": "AgentStudioAssistant"
    },
    "kind": "AliasedInlineFragmentSpread",
    "name": "agent"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "identityAccountId"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v9/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "isVerified"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__id"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "icon"
      },
      {
        "kind": "ScalarField",
        "name": "externalConfigReference"
      },
      {
        "kind": "ScalarField",
        "name": "identityAccountId"
      },
      {
        "kind": "LinkedField",
        "name": "identityAccount",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
          },
          {
            "kind": "ScalarField",
            "name": "picture"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          (v9/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "creatorType"
      },
      {
        "kind": "ScalarField",
        "name": "forgeCreator"
      },
      {
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "authoringTeam",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          (v9/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountStatus"
          },
          (v9/*: any*/)
        ]
      }
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v9/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentProfileCardQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentProfileCardQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "64e256d56df5d7c2723d7002d8836219f0e795e080d865d9e8a8b8724d659c0c",
    "metadata": {},
    "name": "AgentProfileCardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6bb49a428565993244c38618367b96d4";

export default node;
